import { Workflow } from "@finway-group/shared/lib/models"
import axios from "axios"

const model = "workflows"

const WorkflowService = {
    update: async (
        id: string,
        workflowData: Partial<Workflow>,
        otherData: { recalculateApprovalProcessesNotStarted?: boolean; recalculateApprovalProcessesInProgress?: boolean } = {},
    ) => {
        const { data } = await axios.put(`/${model}/${id}`, { ...workflowData, ...otherData })
        return new Workflow(data)
    },
    create: async (workflowData: Partial<Workflow>) => {
        const { data } = await axios.post(`/${model}`, workflowData)
        return new Workflow(data)
    },
    deleteWorkflow: async (id: string, data: { recalculateApprovalProcessesInProgress?: boolean } = {}) => axios.delete(`/${model}/${id}`, { data }),
    fetchOneWorkflow: async (id: string) => {
        const { data } = await axios.get(`/${model}/${id}`)
        return new Workflow(data)
    },
    fetchAllWorkflows: async () => {
        // prettier-ignore
        const { data: { docs } } = await axios.get(`/${model}?limit=1000`);
        return docs.map((doc: any) => new Workflow(doc))
    },
}

export default WorkflowService
